export enum SigninStatus {
  WAIT,
  AUTHORIZED,
  NOTAUTHORIZED,
  SYSTEM_FAILURE,
}
